import {doc} from './docs.js';
import DPad from '../custom/DPad.js';

doc(
    'dpad',
    {
    },
    'A d-pad interface for controlling via bangs',
    () => 0,
    {
        inlets: 0
    });

export const dpad = (object) => {
    let pad = new DPad(object);
    object.effect = pad;

    return () => {
    };
};
